export default __webpack_public_path__ + "b0bf5f1fb06f041e6bf3a5b9b6ea7925.svg";